import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RestRoutes } from '../_config/rest-routes.config';
import { ClaimDisputesDTO } from '../_models/ClaimDisputesDTO.model';
import { UrlSerializer } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ClaimDisputesService {

  httpOptions = {
    headers: new HttpHeaders(
      {
        'Content-Disposition': 'multipart/form-data'
      }
    )
  };

  constructor(private http: HttpClient) { }

  GetDisputes(ClaimOperationID: string): Observable<ClaimDisputesDTO[]> {
    //const url: string = `${environment.urlWS}${RestRoutes. CLAIM_DISPUTES}${ClaimOperationID}${RestRoutes. CLAIM_DISPUTES1}`;
    const url: string = `${environment.urlWS}${RestRoutes.CLAIM_DISPUTES.replace('{ID}',ClaimOperationID)}`;
    return this.http.get<ClaimDisputesDTO[]>(url, this.httpOptions);
  }
}
